import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { baseVanillaSchema } from './shared/base-vanilla.schema';
import { contractTypeSchema } from './shared/contract-type.schema';
import { knockdownInputLevelSchema } from './shared/knockdown-input-level.schema';
import { sideSchema } from './shared/side.schema';
export const vanillaDigitalSchema = baseVanillaSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.VanillaDigital),
    contract_type: contractTypeSchema,
    side: sideSchema,
    coupon_rate_annual: z.number(),
    payoff_barrier_level: z.number(),
    knockdown_input_level: knockdownInputLevelSchema,
});
